<h1 mat-dialog-title>Cambiar Contraseña</h1>
<div mat-dialog-content>
    <form [formGroup]="form">
        <div fxLayout="row wrap">
            <div class="p-10" fxFlex="100">
                <mat-form-field>
                    <input
                        matInput
                        type="password"
                        placeholder="Contraseña actual *"
                        [formControl]="form.controls['actualPwd']"
                    />
                    <mat-hint
                        *ngIf="form.controls['actualPwd'].hasError('required') && form.controls['actualPwd'].touched"
                        class="text-danger font-14"
                        >Debe indicar su contraseña actual</mat-hint
                    >
                </mat-form-field>
            </div>
            <div class="p-10" fxFlex="100">
                <mat-form-field>
                    <input
                        matInput
                        type="password"
                        placeholder="Contraseña nueva *"
                        [formControl]="form.controls['newPwd']"
                    />
                    <mat-hint
                        *ngIf="form.controls['newPwd'].hasError('required') && form.controls['newPwd'].touched"
                        class="text-danger font-14"
                        >Debe indicar su nueva contraseña</mat-hint
                    >
                    <mat-hint
                        *ngIf="form.controls['newPwd'].hasError('minlength') && form.controls['newPwd'].touched"
                        class="text-danger font-14"
                        >La nueva contraseña debe contener al menos 6 carácteres</mat-hint
                    >
                </mat-form-field>
            </div>
            <div class="p-10" fxFlex="100">
                <mat-form-field>
                    <input
                        matInput
                        type="password"
                        placeholder="Repita contraseña nueva *"
                        [formControl]="form.controls['newRepeatedPwd']"
                    />
                    <mat-hint
                        *ngIf="
                            form.controls['newRepeatedPwd'].hasError('required') &&
                            form.controls['newRepeatedPwd'].touched
                        "
                        class="text-danger font-14"
                        >Debe indicar su nueva contraseña</mat-hint
                    >
                    <mat-hint
                        *ngIf="
                            form.controls['newRepeatedPwd'].hasError('equalTo') &&
                            form.controls['newRepeatedPwd'].touched
                        "
                        class="text-danger font-14"
                        >Contraseña no coincide</mat-hint
                    >
                </mat-form-field>
            </div>
        </div>
    </form>
</div>
<div mat-dialog-actions>
    <button mat-raised-button color="accent" (click)="onCancel()" tabindex="2">Cancelar</button>
    <button mat-raised-button color="primary" (click)="onChange()" [disabled]="!form.valid || isSaving" tabindex="1">
        Cambiar
    </button>
</div>
